import { render } from "./Products.vue?vue&type=template&id=2b9a689e&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"

import "./Products.vue?vue&type=style&index=0&id=2b9a689e&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9a689e"],['__file',"src/components/products/ios/Products.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2b9a689e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2b9a689e', __exports__)) {
    console.log('reload')
    api.reload('2b9a689e', __exports__)
  }
  
  module.hot.accept("./Products.vue?vue&type=template&id=2b9a689e&scoped=true", () => {
    console.log('re-render')
    api.rerender('2b9a689e', render)
  })

}


export default __exports__